import React from 'react';
import PropTypes from 'prop-types';
import GrantsItem from '../grantsItem';

// Config.
import { GRANTS_SHAPE } from '../../../config/prop-types';

// Styles.
import './grantsList.scss';

/**
 * Grants App - List component.
 */
export default class GrantsList extends React.PureComponent {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.onGrantSelect = this.onGrantSelect.bind(this);
  }
  /**
   * Toggle open and closed the filter item.
   */
  onGrantSelect(grant, visible) {
    const {
      history,
    } = this.props;
    const {
      // eslint-disable-next-line react/prop-types
      location,
    } = history;

    // If a slug exists, and it's hidden, proceed.
    if (grant.slug && false === visible) {
      // eslint-disable-next-line react/prop-types
      history.push(`/grants/${grant.slug}`);
    } else if (grant.slug && true === visible) {
      // Else, if the item is visible, and the slug matches the URL, reset.
      const pathName = `/grants/${grant.slug}`;
      // eslint-disable-next-line react/prop-types
      if (location.pathname === pathName) {
        // eslint-disable-next-line react/prop-types
        history.push('/grants/');
      }
    }
  }

  /**
   * Renders this component.
   * @returns {object} Component markup.
   */
  render() {
    const {
      filteredGrants,
      grantsVisible,
      history,
      initialGrantSlug,
      location,
    } = this.props;
    return (
      <div className="grants__list">
        {0 < filteredGrants.length ?
          filteredGrants.slice(0, grantsVisible).map((grant) => (
            <GrantsItem
              grant={grant}
              history={history}
              initialGrantSlug={initialGrantSlug}
              key={grant.id}
              location={location}
              clickHandler={this.onGrantSelect}
            />
          )) :
          <div className="grants__list--type--empty">
            No matching grants found.
          </div>
        }
      </div>
    );
  }
}

GrantsList.propTypes = {
  grantsVisible: PropTypes.number.isRequired,
  filteredGrants: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.shape(GRANTS_SHAPE)),
  ]).isRequired,
  history: PropTypes.shape({}).isRequired,
  initialGrantSlug: PropTypes.string.isRequired,
  location: PropTypes.shape({}).isRequired,
};
